<template lang="pug">
  veeno(
    connect
    :tooltips="tooltips()"
    :step="1"
    :range="range"
    :handles="value"
    v-on="inputListeners"
    @set="set"
    )
</template>

<script>
import veeno from 'veeno';
import 'nouislider/distribute/nouislider.min.css';

export default {
  name: 'CommonRange',
  components: { veeno },
  props: {
    range: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  methods: {
    set(e) {
      this.$emit('input', e.unencoded);
    },
    tooltips() {
      return [
        { from: (v) => parseInt(v, 10), to: (v) => parseInt(v, 10) },
        { from: (v) => parseInt(v, 10), to: (v) => parseInt(v, 10) },
      ];
    },
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: () => { /* disable default input event */ },
      };
    },
  },
};
</script>

<style lang="scss">
/* does not work with scoped attribute because nouislider plugin generates html dynamically */
.noUi {
  &-horizontal  {
    height: 8px;
    .noUi-tooltip {
      -webkit-transform: translate(-50%, 0);
      transform: translate(-50%, 0);
      left: 50%;
      bottom: auto;
      top: calc(100% + 8px);
      border: none;
      font-size: 12px;
      line-height: 16px;
      color: var(--color-middle-gray);
      background: transparent;
    }
  }
  &-connect {
    background-color: var(--color-turquoise);
  }
  &-handle {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border: 5px solid var(--color-turquoise);
    border-radius: 100%;
    outline: none;
    &:before,
    &:after {
      display: none;
    }
  }
  &-target {
    border: none;
    border-radius: 33px;
    box-shadow: none;
    background: var(--color-super-light);
  }
}
.noUi-horizontal .noUi-handle {
  left: 22px;
  right: 0;
  top: -6px;
  width: 22px;
  height: 22px;
  cursor: pointer;
}
</style>
